/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./lazyAudio.vue?vue&type=template&id=10434c28&scoped=true&"
import script from "./lazyAudio.vue?vue&type=script&lang=js&"
export * from "./lazyAudio.vue?vue&type=script&lang=js&"
import style0 from "./lazyAudio.vue?vue&type=style&index=0&id=10434c28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10434c28",
  null
  
)

export default component.exports